module.exports = __webpack_public_path__ + "static/img/bannerNew.e03c79e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Virus/Adeno/bannerNew.jpg
// module id = qs1q
// module chunks = 16